export const isKeycloakAuthEnabled = () => {
  const ENVIRONMENT_NAME = process.env.ENVIRONMENT_NAME;

  if (typeof window !== "undefined") {
    const params = new URLSearchParams(window.location.search);
    if (params.get("disable_new_auth") === "true") {
      window.localStorage.removeItem("DEV_USE_KEYCLOAK");
      params.delete("disable_new_auth");
      const newUrl = params.toString() ?
        `${window.location.pathname}?${params}` :
        window.location.pathname;
      window.history.replaceState({}, "", newUrl);
      return false;
    }
  }

  if (
    ENVIRONMENT_NAME !== "production" &&
    typeof window !== "undefined" &&
    window.localStorage.getItem("DEV_USE_KEYCLOAK") === "true"
  ) {
    return true;
  }

  return process.env.AUTH_USE_KEYCLOAK === "true" || process.env.AUTH_USE_KEYCLOAK === true;
};
